import { IntlProvider } from 'react-intl'
import { Routes, Route } from 'react-router-dom'

import English from './locales/en-us.json'
import Brazilian from './locales/pt-br.json'
import AuthProvider from './apis/auth/AuthProvider';
import PrivateRoute from './router/PrivateRoute';
import FormGiantsysTracking from './concepts/giantsys-tracking/components/templates/FormGiantsysTracking'
import Home from './pages/Home'
import Login from './pages/Login'
import NotFound from './pages/NotFound'
import useProfileData from './concepts/giantsys-tracking/hooks/useProfileData';
import ShowHouseFields from './pages/ShowHouse';
import ReportTemplate from './concepts/giantsys-tracking/components/templates/ReportTemplate';
import { RoutesReportPending } from './pages/ReportPending';

function App() {
  const ProfileData = useProfileData();
  const defaultLocale = "en-us";
  const Languages = {
    "en-us": English,
    "pt-br": Brazilian
  };

  function listRoutes() {
    return ProfileData.userAccess && ProfileData.userAccess.map(rt => (
      <Route key={rt.id} exact={true} path={rt.href} element={ <FormGiantsysTracking trackingSysId={rt.id} ModelList={ProfileData.modelList} />  }/>
      ));
  };
  function listRouteReportPending(){
    return RoutesReportPending && RoutesReportPending.map((rt, id) => (
      <Route key={id} exact={true} path={rt.href} element={ <ReportTemplate trackingSysId={rt.trackingSysId} titleReport={rt.titleReport} />  }/>
    ));
  };
  
  return (
    <AuthProvider>
      <IntlProvider locale={ProfileData.userLocale in Languages ? ProfileData.userLocale : defaultLocale} messages={Languages[ProfileData.userLocale] || Languages[defaultLocale]}>
        <Routes>
          <Route path="/login" element={<Login />} />
          { listRouteReportPending() ?? (<></>) }
          <Route path="/cisco" element={<ShowHouseFields />} />
          <Route path='/' exact={true} element={ 
            <PrivateRoute sidebarItemList={ProfileData.userAccess} handleVerifyLogin={ProfileData.handleVerifyLogin} routesReportPending={RoutesReportPending}/>
          }>
            <Route exact={true} path='/home' element={<Home routes={ProfileData.userAccess} />} />
            { listRoutes() ?? (<></>) }
            <Route path="*" element={<NotFound dynamicLocations={ProfileData.userAccess} />} />
          </Route>
        </Routes>
      </IntlProvider>
    </AuthProvider>
  ); 
}

export default App;